import Image from '@public/images/fintech-public-explanations.png'

import { BlogPreview } from '@/components/blogSlices/BlogPreview'
import TextWithImageGoingOffScreen from '@/components/TextWithImageGoingOffScreen/TextWithImageGoingOffScreen'

export default function FintechExplanations() {
    return (
        <TextWithImageGoingOffScreen
            title={`Audit-ready calculation breakdowns`}
            paragraph={`Leave the emission explanations to us. Fast-track your customers’ climate compliance with step-by-step emission calculation breakdowns that show how they were calculated and what assumptions were made.`}
            img={Image}
            snippet={
                <BlogPreview
                    title={'How to get audit-ready using Lune emission explanations'}
                    url={'/blog/audit-ready-emission-calculation-explanations'}
                />
            }
        />
    )
}
